import { render, staticRenderFns } from "./HandleAssignTemplateSidebar.vue?vue&type=template&id=52babc86&scoped=true&"
import script from "./HandleAssignTemplateSidebar.vue?vue&type=script&lang=js&"
export * from "./HandleAssignTemplateSidebar.vue?vue&type=script&lang=js&"
import style0 from "./HandleAssignTemplateSidebar.vue?vue&type=style&index=0&id=52babc86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52babc86",
  null
  
)

export default component.exports